(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/components/mobile-confirm.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/components/mobile-confirm.js');
'use strict';

const {
  useEffect,
  useState
} = React;
const Button = svs.ui.ReactButton;
const isPnp = svs.core.config.data.svsconfig.site === 'momang';
const {
  getCustomersPreferences,
  setForceSaveMobile
} = svs.myProfile.react.store.pdPreferences.actions;
const {
  FULFILLED,
  REJECTED
} = svs.myProfile.constants.thunkStatus;
const {
  putSendMobileVerificationCodeAsync
} = svs.myProfile.react.pages.myInformation.myInformationService;
const {
  showTechnicalError,
  showMobileConfirmedFlash,
  showMobileVerificationCodeSent
} = svs.myProfile.react.shared.dialogs;

const MobileConfirm = () => {
  const dispatch = ReactRedux.useDispatch();
  const location = ReactRouterDOM.useLocation();
  const {
    mobile,
    customerId
  } = ReactRedux.useSelector(state => state.playerCustomizedSettings.playerCustomizedSettings);
  const {
    status: playerCustomizedSettingsStatus
  } = ReactRedux.useSelector(state => state.playerCustomizedSettings.playerCustomizedSettingsStatus);
  const [returnUrl, setReturnUrl] = useState('');
  useEffect(() => {
    dispatch(getCustomersPreferences());
  }, [dispatch]);
  useEffect(() => {
    var _queryStringObject;
    let queryStringObject = svs.utils.url.queryString;
    if ('URLSearchParams' in window) {
      const urlParamsFunctions = new URLSearchParams(location.search);
      queryStringObject = {
        returnUrl: urlParamsFunctions.get('returnUrl'),
        cancelUrl: urlParamsFunctions.get('cancelUrl')
      };
    }
    if ((_queryStringObject = queryStringObject) !== null && _queryStringObject !== void 0 && _queryStringObject.returnUrl) {
      setReturnUrl(queryStringObject.returnUrl);
    }
  }, [location.search]);
  useEffect(() => {
    if (playerCustomizedSettingsStatus === FULFILLED || playerCustomizedSettingsStatus === REJECTED) {
      if (!customerId) {
        showTechnicalError();
      }
    }
  }, [customerId, playerCustomizedSettingsStatus]);

  const handleSendNewCodeClick = async () => {
    try {
      const {
        error
      } = await putSendMobileVerificationCodeAsync();
      if (error) {
        switch (error.code) {
          case 12010:
            showTechnicalError();
            break;
          case 12015:
            showTechnicalError();
            break;
          case 12017:
            showTechnicalError();
            break;
          default:
        }
      } else {
        showMobileVerificationCodeSent(mobile);
      }
    } catch (error) {
      svs.myProfile.logger.warn("Unhandled error code when confirming verification sms: ".concat(error.code));
      showTechnicalError();
    }
  };
  showMobileConfirmedFlash(mobile, returnUrl);

  const setForceSaveTrue = () => {
    dispatch(setForceSaveMobile(true));
  };
  return React.createElement("div", null, playerCustomizedSettingsStatus === FULFILLED && React.createElement(React.Fragment, null, React.createElement("p", {
    className: "f-center margin-v-1"
  }, "Bekr\xE4fta ditt mobilnummer genom att anv\xE4nda l\xE4nken vi har skickat till mobilnumret du har angivit."), React.createElement(Button, {
    block: true,
    className: "margin-v-1",
    inverted: isPnp,
    onClick: handleSendNewCodeClick,
    transparent: true
  }, "Skicka ny l\xE4nk"), React.createElement(Button, {
    block: true,
    id: "forceSave",
    inverted: isPnp,
    onClick: setForceSaveTrue,
    transparent: true
  }, "Ange nytt mobilnummer")));
};
svs.myProfile.react.pages.myInformation.myInformation.mobile.MobileConfirm = MobileConfirm;

 })(window);